import { xray } from 'lib/xray';
import { EnvironmentSelectors } from 'reactApp/modules/environment/environment';
import { closePopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { addPromoToShowQueue, promoShown } from 'reactApp/modules/promo/promo.module';
import { PromoSelectors } from 'reactApp/modules/promo/promo.selectors';
import { EPromoType } from 'reactApp/modules/promo/promo.types';
import { historyPush } from 'reactApp/modules/router/router.module';
import { store as reduxStore, store } from 'reactApp/store';
import { renderFamilyTariffModal } from 'reactApp/ui/FamilyTariffModal/FamilyTariffModal.helpers';
import { put } from 'redux-saga/effects';
import { call, select } from 'typed-redux-saga';

const PROMO_ID = 'family-buy-modal';

export function* initWelcomeNewFamilyTariffDialog() {
    const project = 'cloud-web-analytics';
    const isMobile = EnvironmentSelectors.isMobile();

    const queryParam = new URLSearchParams(window?.location?.search).get('action');
    const promoAlreadyShown: boolean = storeHelper.getValue(PROMO_ID);

    if (queryParam !== 'new-family-tariff-success' || isMobile || promoAlreadyShown) {
        return;
    }

    yield put(
        addPromoToShowQueue({
            type: EPromoType.showFamilyBuyModal,
            promoId: PROMO_ID,
            isMobile,
            onShow: () => {
                storeHelper.markAsShown(PROMO_ID);
                xray.send('show_communication_start_family_sub', { p: project });
                reduxStore.dispatch(promoShown(EPromoType.showFamilyBuyModal));
            },

            onPrimaryClick: () => {
                if (isMobile) {
                    closePopupHelper(popupNames.FAMILY_TARIFF_MODAL);
                }

                xray.send('click_communication_start_family_sub', { p: project, dwh: { button: 'add_members' } });
                store.dispatch(historyPush({ id: '/family' }));
            },

            onSecondaryClick: () => {
                if (isMobile) {
                    closePopupHelper(popupNames.FAMILY_TARIFF_MODAL);
                }

                xray.send('click_communication_start_family_sub', { p: project, dwh: { button: 'later' } });
            },
            onClose: () => {},
        })
    );
}

export function* showFamilyBuyModal() {
    const isMobile = EnvironmentSelectors.isMobile();
    const promo = yield* select(PromoSelectors.getPromo(EPromoType.showFamilyBuyModal));

    if (!promo) {
        return;
    }

    const { onShow, onPrimaryClick, onSecondaryClick, onClose } = promo;

    yield call(renderFamilyTariffModal, {
        isMobile,
        onShow,
        onClose,
        onPrimaryClick,
        onSecondaryClick,
    });
}
